// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `v-person-search-base .searchbar, v-person-search .searchbar, v-person-search-dropdown .searchbar {
  position: relative;
}
v-person-search-base .searchbar .search-icon, v-person-search .searchbar .search-icon, v-person-search-dropdown .searchbar .search-icon {
  position: absolute;
  top: 12px;
  left: 14px;
  z-index: 1;
}
v-person-search-base .searchbar .load-icon, v-person-search-base .searchbar .clear-icon, v-person-search .searchbar .load-icon, v-person-search .searchbar .clear-icon, v-person-search-dropdown .searchbar .load-icon, v-person-search-dropdown .searchbar .clear-icon {
  position: absolute;
  top: 12px;
  right: 14px;
}
v-person-search-base .searchbar .load-icon, v-person-search .searchbar .load-icon, v-person-search-dropdown .searchbar .load-icon {
  right: 12px !important;
}
v-person-search-base .searchbar input, v-person-search .searchbar input, v-person-search-dropdown .searchbar input {
  padding: 0.5rem 0.5rem 0.5rem 2.5rem !important;
}
v-person-search-base v-avatar, v-person-search v-avatar, v-person-search-dropdown v-avatar {
  width: 30px;
  height: 30px;
}
v-person-search-base .selector, v-person-search-base .avatar, v-person-search .selector, v-person-search .avatar, v-person-search-dropdown .selector, v-person-search-dropdown .avatar {
  min-width: 47px !important;
  width: 30px;
}
v-person-search-base th, v-person-search-base td, v-person-search th, v-person-search td, v-person-search-dropdown th, v-person-search-dropdown td {
  min-width: 160px !important;
}
v-person-search-base tr.p-datatable-row-selected td, v-person-search tr.p-datatable-row-selected td, v-person-search-dropdown tr.p-datatable-row-selected td {
  background: var(--p-datatable-row-selected-background) !important;
}
v-person-search-base tr:not(.p-datatable-row-selected):hover td, v-person-search tr:not(.p-datatable-row-selected):hover td, v-person-search-dropdown tr:not(.p-datatable-row-selected):hover td {
  background: var(--p-datatable-row-hover-background) !important;
}
v-person-search-base tr.p-highlight td, v-person-search-base tr.p-highlight th, v-person-search tr.p-highlight td, v-person-search tr.p-highlight th, v-person-search-dropdown tr.p-highlight td, v-person-search-dropdown tr.p-highlight th {
  background: var(--gc-color-primary) !important;
}
v-person-search-base .image, v-person-search .image, v-person-search-dropdown .image {
  display: block;
  overflow: hidden;
  border-radius: 50%;
  height: 30px;
  width: 30px;
}
v-person-search-base .chips > *, v-person-search .chips > *, v-person-search-dropdown .chips > * {
  display: inline-flex;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
}
v-person-search-base .chips > *:last-child, v-person-search .chips > *:last-child, v-person-search-dropdown .chips > *:last-child {
  margin-right: 0;
}
v-person-search-base :host:not(v-person-search-dropdown), v-person-search :host:not(v-person-search-dropdown), v-person-search-dropdown :host:not(v-person-search-dropdown) {
  height: 100%;
}
v-person-search-base .gc-component, v-person-search .gc-component, v-person-search-dropdown .gc-component {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
v-person-search-base .gc-component .scroll-container, v-person-search .gc-component .scroll-container, v-person-search-dropdown .gc-component .scroll-container {
  flex-grow: 1;
  position: relative;
}
v-person-search-base .gc-component .scroll-container .scroll-content, v-person-search .gc-component .scroll-container .scroll-content, v-person-search-dropdown .gc-component .scroll-container .scroll-content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: overlay;
}
v-person-search-base .text-button, v-person-search .text-button, v-person-search-dropdown .text-button {
  text-decoration: underline;
  color: var(--gc-color-primary);
  cursor: pointer;
}
v-person-search-base .separator, v-person-search .separator, v-person-search-dropdown .separator {
  border-right: 1px solid var(--gc-border-color);
  min-height: 28px;
}
v-person-search-base .fields, v-person-search .fields, v-person-search-dropdown .fields {
  align-items: flex-start;
}
v-person-search-base .fields, v-person-search-base .fields > *, v-person-search .fields, v-person-search .fields > *, v-person-search-dropdown .fields, v-person-search-dropdown .fields > * {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
v-person-search-base .field, v-person-search .field, v-person-search-dropdown .field {
  margin-bottom: 0;
  cursor: pointer;
}
v-person-search-base .group .label, v-person-search .group .label, v-person-search-dropdown .group .label {
  background: var(--box-background);
  border: 1px solid var(--gc-border-color);
  border-radius: 8px;
  display: inline-flex;
  padding: 0.1rem 0.25rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  gap: 0.25rem;
}
v-person-search-base .group .label.selected, v-person-search .group .label.selected, v-person-search-dropdown .group .label.selected {
  background: var(--gc-color-secondary);
}
v-person-search-base .group .label.active, v-person-search .group .label.active, v-person-search-dropdown .group .label.active {
  background: var(--gc-color-primary);
  color: var(--gc-text-color-inverse);
}
v-person-search-base .progressbar, v-person-search .progressbar, v-person-search-dropdown .progressbar {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 100;
}
v-person-search-base .avatar .container, v-person-search .avatar .container, v-person-search-dropdown .avatar .container {
  position: relative;
  width: 30px;
  height: 30px;
}
v-person-search-base .avatar .container .color-overlay, v-person-search .avatar .container .color-overlay, v-person-search-dropdown .avatar .container .color-overlay {
  background: var(--color);
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  mix-blend-mode: screen;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.15);
}

v-person-search {
  min-height: 500px;
  min-width: 500px;
  display: grid;
}

.icon {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-person-search/component/v-person-search.component.sass"],"names":[],"mappings":"AAGI;EACI,kBAAA;AAFR;AAGQ;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AADZ;AAEQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AAAZ;AACQ;EACI,sBAAA;AACZ;AAAQ;EACI,+CAAA;AAEZ;AAAI;EACI,WAAA;EACA,YAAA;AAER;AAAI;EACQ,0BAAA;EACA,WAAA;AAEZ;AADI;EACI,2BAAA;AAGR;AAAI;EACI,iEAAA;AAER;AADI;EACI,8DAAA;AAGR;AADQ;EACI,8CAAA;AAGZ;AADI;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,YA1CK;EA2CL,WA3CK;AA8Cb;AADQ;EACI,oBAAA;EACA,oBAAA;EACA,qBAAA;AAGZ;AAFY;EACI,eAAA;AAIhB;AAHI;EACI,YAAA;AAKR;AAJI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAMR;AALQ;EACI,YAAA;EACA,kBAAA;AAOZ;AANY;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,iBAAA;AAQhB;AANI;EACI,0BAAA;EACA,8BAAA;EACA,eAAA;AAQR;AANI;EACI,8CAAA;EACA,gBAAA;AAQR;AANI;EACI,uBAAA;AAQR;AAPI;EACI,oBAAA;EACA,eAAA;EACA,WAAA;AASR;AANI;EACI,gBAAA;EACA,eAAA;AAQR;AANI;EACI,iCAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,YAAA;AAQR;AAPQ;EACI,qCAAA;AASZ;AARQ;EACI,mCAAA;EACA,mCAAA;AAUZ;AARI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AAUR;AAPQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AASZ;AARY;EACI,wBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,qCAAA;AAUhB;;AARA;EACI,iBAAA;EACA,gBAAA;EACA,aAAA;AAWJ;;AATA;EACI,aAAA;AAYJ","sourcesContent":["$image_size: 30px\n\nv-person-search-base, v-person-search, v-person-search-dropdown\n    .searchbar\n        position: relative\n        .search-icon\n            position: absolute\n            top: 12px\n            left: 14px\n            z-index: 1\n        .load-icon, .clear-icon\n            position: absolute\n            top: 12px\n            right: 14px\n        .load-icon\n            right: 12px !important\n        input\n            padding: 0.5rem 0.5rem 0.5rem 2.5rem !important\n\n    v-avatar\n        width: 30px\n        height: 30px\n\n    .selector, .avatar\n            min-width: 47px !important\n            width: 30px\n    th, td\n        min-width: 160px !important\n    // td.p-datatable-frozen-column // Causes issues with overlapping background text when using frozen columns\n    //     background: unset !important\n    tr.p-datatable-row-selected td\n        background: var(--p-datatable-row-selected-background) !important\n    tr:not(.p-datatable-row-selected):hover td\n        background: var(--p-datatable-row-hover-background) !important\n    tr.p-highlight\n        td, th\n            background: var(--gc-color-primary) !important\n\n    .image\n        display: block\n        overflow: hidden\n        border-radius: 50%\n        height: $image_size\n        width: $image_size\n    .chips\n        > *\n            display: inline-flex\n            margin-right: 0.5rem\n            margin-bottom: 0.5rem\n            &:last-child\n                margin-right: 0\n    :host:not(v-person-search-dropdown)\n        height: 100%\n    .gc-component\n        height: 100%\n        display: flex\n        flex-direction: column\n        gap: 0.5rem\n        .scroll-container\n            flex-grow: 1\n            position: relative\n            .scroll-content\n                position: absolute\n                top: 0\n                right: 0\n                bottom: 0\n                left: 0\n                overflow: overlay\n\n    .text-button\n        text-decoration: underline\n        color: var(--gc-color-primary)\n        cursor: pointer\n\n    .separator\n        border-right: 1px solid var(--gc-border-color)\n        min-height: 28px\n\n    .fields\n        align-items: flex-start\n    .fields, .fields > * \n        display: inline-flex\n        flex-wrap: wrap\n        gap: 0.5rem\n\n\n    .field\n        margin-bottom: 0\n        cursor: pointer\n\n    .group .label\n        background: var(--box-background)\n        border: 1px solid var(--gc-border-color)\n        border-radius: 8px\n        display: inline-flex\n        padding: 0.1rem 0.25rem\n        cursor: pointer\n        user-select: none\n        display: flex\n        gap: 0.25rem\n        &.selected\n            background: var(--gc-color-secondary)\n        &.active\n            background: var(--gc-color-primary)\n            color: var(--gc-text-color-inverse)\n\n    .progressbar\n        position: absolute\n        left: 0\n        right: 0\n        z-index: 100\n\n    .avatar\n        .container    \n            position: relative\n            width: 30px\n            height: 30px\n            .color-overlay\n                background: var(--color)\n                width: 100%\n                height: 100%\n                display: block\n                position: absolute\n                mix-blend-mode: screen\n                user-select: none\n                pointer-events: none\n                top: 0\n                bottom: 0\n                left: 0\n                right: 0\n                border-radius: 50%\n                border: 1px solid rgba(0, 0, 0, 15%)\n\nv-person-search\n    min-height: 500px\n    min-width: 500px\n    display: grid\n\n.icon\n    display: flex"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
